import {
  IconButton,
  Drawer,
  Toolbar,
  Paper,
  Divider,
  MenuList,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import * as React from 'react';
import styles from './Header.module.css';
import HeaderMobileMenuLink from './HeaderMobileMenuLink';

interface IProps {
  links: Array<
    Array<{
      link: string;
      label: string;
      action?: Function;
    }>
  >;
}

function HeaderMobileMenu({ links }: IProps) {
  const [showMenu, setShowMenu] = React.useState<boolean>(false);

  const handleOpenNavMenu = () => {
    setShowMenu(true);
  };

  const handleCloseNavMenu = () => {
    setShowMenu(false);
  };

  return (
    <>
      <IconButton
        size='large'
        aria-label='menu icon'
        aria-controls='menu-appbar'
        aria-haspopup='true'
        onClick={() => (showMenu ? handleCloseNavMenu() : handleOpenNavMenu())}
        color='inherit'
        sx={{ color: 'primary.main' }}
      >
        {showMenu === false && <MenuIcon />}
        {showMenu && <CloseIcon />}
      </IconButton>
      <Drawer
        variant='temporary'
        anchor='top'
        open={showMenu}
        onClose={handleCloseNavMenu}
        sx={{
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <Paper
          sx={{
            overflow: 'auto',
            backgroundColor: 'secondary.main',
            color: 'whitesmoke',
          }}
        >
          <MenuList onClick={handleCloseNavMenu} className={styles.menuList}>
            {links.map((_links, index) => (
              <div key={index}>
                {_links.map((link) => (
                  <HeaderMobileMenuLink
                    key={link.label}
                    to={link.link}
                    label={link.label}
                    action={link.action}
                  />
                ))}
                {index < links.length - 1 && (
                  <Divider
                    key={'divider_' + index}
                    sx={{ background: 'grey' }}
                    variant='middle'
                  />
                )}
              </div>
            ))}
          </MenuList>
        </Paper>
      </Drawer>
    </>
  );
}

export default HeaderMobileMenu;
